import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../api/api.service';
import { Setting } from '../../models/setting';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  public setting?: Setting;
  public loadedSettings: boolean = false;

  constructor(
    private readonly _api: ApiService
  ) { }

  /**
   * Get Settings.
   * @returns Setting.
   */
  public getSettings$(): Observable<Setting | undefined> {
    return this._api.get$('settings', '') as Observable<Setting | undefined>;
  }

  /**
   * Create or update Settings.
   * @param body Settings properties.
   * @returns Setting.
   */
  public setSettings$(body: Setting): Observable<void> {
    return this._api.post$('settings', '', undefined, undefined, body)
  }
}